// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  background-color: lightgray;
  margin: 0;
  line-height: 20px;
  font-size: 14px;
}

p {
  margin: 10px 0 0;
}

a {
  color: rgb(1 50 153);
  font-weight: 600;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 600;
  margin: 0;
}

h3 a:visited {
  color: black;
}

h3 {
  font-size: 20px;
}

h4 {
  font-size: 17px;
}

h5 {
  font-size: 14px;
}

h6 {
  font-size: 13px;
}

ul {
  margin: 0;
}

.a-button {
  color: rgb(1 50 153);
  font-weight: 600;
  cursor: pointer;
  padding: 0 1px;
}

#app {
  background-color: rgb(102 153 204);
  width: 1310px;
  height: auto;
  margin: auto;
  overflow: hidden;
}

#header {
  height: 250px;
  background-color: rgb(1 50 153);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#header-info {
  color: white;
  align-self: flex-end;
  padding: 0 30px 0 0;
  height: 5px;
}

#header-info span {
  color: white;
  align-self: flex-end;
  font-weight: 400;
}

#header-pic-img {
  height: 180px;
  object-fit: cover;
}

#nav {
  height: 3vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: rgb(102 153 204);
}

#nav a {
  color: white;
  font-weight: 400;
}

#nav-div {
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#footer {
  height: 10vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-top: 2px solid white;
  background-color: lightgray;
}

#footer-nav {
  height: 3vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: lightgray;
}

#footer-nav a {
  font-weight: 400;
}

#footer-copyright {
  display: flex;
  align-items: flex-end;
  height: 50px;
  font-size: 10px;
}

/* Landing Page */

#landing {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  padding: 40px;
}

#landing-main {
  background-color: lightgray;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#landing-main-logo {
  padding-bottom: 10px;
}

#landing-main-logo-img {
  width: 50px;
  padding-bottom: 20px;
}

#landing-action {
  display: flex;
  flex-direction: row;
  justify-content: center;
  white-space: pre;
  padding-top: 15px;
}

/* Profile */

#profile,
#content {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 0 50px 50px;
}

.profile-firstName,
.profile-lastName {
  padding: 30px 0 20px;
  color: black;
  cursor: default;
  word-break: break-all;
}

#profile-layout {
  height: 100%;
  display: grid;
  grid-template-columns: auto auto;
  grid-template-areas: "left right";
}

#profile-left {
  grid-area: left;
  width: 400px;
  padding-right: 25px;
  justify-self: left;
}

#profile-right {
  grid-area: right;
  min-width: 450px;
  width: 760px;
  padding-left: 25px;
  justify-self: left;
}

/* Profile Left Side */

#description {
  display: grid;
  grid-template: "name name" auto "pic desc" 200px "mood login" 75px / 250px;
}

#description-pic {
  grid-area: pic;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

#description-pic-img {
  width: 100%;
  object-fit: cover;
}

#description-mood-view {
  grid-area: mood;
  white-space: pre;
  padding: 18px 20px 0 0;
  height: 20px;
  display: grid;
  grid-template-rows: 22px auto;
  grid-template-areas:
    "mood"
    "view";
}

#description-mood {
  display: flex;
  flex-direction: row;
  grid-area: mood;
}

#description-mood-name {
  height: 25px;
}

#description-mood-current {
  height: 25px;
  grid-area: current;
  justify-self: flex-start;
}

#description-mood-current-emoji {
  height: 25px;
  grid-area: emoji;
  justify-self: flex-start;
}

#description-view-pics {
  height: 20px;
  grid-area: view;
  display: flex;
  flex-direction: row;
  white-space: pre;
}

#description-view-pics a {
  font-weight: 600;
}

#description-desc {
  white-space: pre;
  padding: 0 20px;
  grid-area: desc;
  display: flex;
  flex-direction: column;
}

#description-desc-status {
  height: 40px;
  display: flex;
  flex-direction: row;
  white-space: pre;
}

#description-desc-status-text {
  white-space: pre-wrap;
  word-break: break-all;
}

#description-desc-status-text-quote {
  margin-left: -4px;
}

#description-desc-gender,
#description-desc-age,
#description-desc-city,
#description-desc-state,
#description-desc-country,
#description-desc-login-date {
  height: 20px;
}

#description-desc-login {
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

#contact-layout {
  line-height: 15px;
  display: grid;
  grid-template: "left right" auto / 180px auto;
  white-space: pre;
  box-sizing: border-box;
}

#contact-name,
#interests-name,
#details-name,
#content-list-name {
  height: 30px;
  background-color: rgb(102 153 204);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
  color: white;
  box-sizing: border-box;
  word-break: break-all;
  white-space: pre-wrap;
  margin-top: -2px;
}

#contact-name-text {
  white-space: pre;
}

#details-name-text,
#interests-name-text,
#content-list-name-text {
  white-space: pre;
  margin-left: -4px;
}

#contact-left {
  grid-area: left;
  padding: 20px 0 20px 10px;
  justify-self: center;
}

#contact-right {
  grid-area: right;
  padding: 20px 10px 20px 0;
}

.contact-link {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 7px 0;
  height: 20px;
}

.contact-icon {
  font-size: 20px;
  padding: 0 10px 0 20px;
}

#url {
  border: 1px solid rgb(102 153 204);
  padding: 5px 10px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 30px;
}

#url-name,
#url-address {
  display: flex;
  align-items: center;
  white-space: pre-wrap;
  word-break: break-all;
}

#url-address {
  padding: 0 15px;
}

#url-address-text {
  white-space: pre-wrap;
  word-break: break-all;
}

#url-name {
  font-weight: 600;
}

#interests,
#details,
#contact,
#content-list {
  border: 2px solid rgb(102 153 204);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-bottom: 15px;
}

#contact,
#content-list {
  margin-bottom: 30px;
}

#interests-name,
#details-name {
  padding-left: 10px;
}

#interests-main,
#details-main {
  padding: 4px 0 0 4px;
}

#interests-general,
#interests-music,
#interests-movies,
#interests-television,
#interests-books,
#interests-heroes,
#details-status,
#details-here,
#details-hometown,
#details-zodiac,
#details-smoke,
#details-occupation {
  display: flex;
  flex-direction: row;
  padding: 0 4px 4px 0;
}

.interests-left,
.details-left {
  grid-area: left;
  width: 150px;
  margin-right: 4px;
  background-color: rgb(177 208 240);
}

.interests-right,
.details-right {
  grid-area: right;
  width: 250px;
  background-color: rgb(214 231 251);
}

.interests-section,
.details-section {
  color: rgb(52 102 153);
  min-height: 30px;
  padding: 4px;
  width: 100% - 4px;
  height: 100% - 4px;
}

.interests-text,
.details-text {
  min-height: 30px;
  padding: 4px;
  width: 100% - 4px;
  height: 100% - 4px;
}

/* Profile Right Side */

#headline {
  border: 2px solid black;
  padding: 35px;
  line-height: 30px;
  height: 130px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

#headline-name {
  word-break: break-all;
  white-space: pre-wrap;
}

#headline-text {
  word-break: break-all;
  white-space: pre-wrap;
}

#headline-text-content {
  white-space: pre;
}

#profile-content {
  padding: 25px 0;
  display: grid;
  grid-template: "center" auto / auto;
}

#profile-content-title,
#profile-content-title-name,
#profile-content-subscribe,
#profile-content-head {
  height: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: row;
  white-space: nowrap;
}

#profile-content-title-name {
  white-space: pre-wrap;
  word-break: break-all;
}

#profile-content-title-text {
  white-space: nowrap;
  margin-left: -4px;
}

#profile-content-subscribe {
  padding-left: 5px;
}

#profile-content-text {
  grid-area: center;
  width: 100%;
}

.profile-content-post {
  width: auto;
  height: 20px;
  padding-bottom: 20px;
  display: flex;
}

.profile-content-post-title {
  width: auto;
  word-break: break-all;
  white-space: pre-wrap;
}

.profile-content-post-more {
  white-space: nowrap;
}

#profile-content-view-all {
  display: flex;
  flex-direction: row;
}

#subscribe {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgb(255 255 255 / 50%);
  grid-area: center;
  z-index: 1;
  padding-top: 30px;
}

#subscribe-name {
  height: 30px;
  background-color: rgb(102 153 204);
  display: grid;
  grid-template-columns: auto 20px;
  grid-template-rows: auto;
  padding-left: 10px;
  color: white;
  box-sizing: border-box;
  align-items: center;
}

#subscribe-box {
  background-color: rgb(214 231 251);
  border: 2px solid rgb(102 153 204);
  width: 100%;
  min-width: 200px;
  max-width: 400px;
  height: 200px;
  display: flex;
  flex-direction: column;
}

#subscribe-close {
  font-size: 16px;
  color: white;
  cursor: pointer;
}

#subscribe-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgb(52 102 153);
  line-height: 20px;
  margin: auto;
  padding: 20px;
}

#subscribe-text form {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 5px;
}

#subscribe-text-name {
  word-break: break-all;
  white-space: pre-wrap;
  display: flex;
  flex-direction: row;
}

#subscribe-text-name-text {
  white-space: pre;
}

#subscribe-email {
  width: 200px;
  height: 20px;
  grid-area: email;
  border: 1px solid rgb(102 153 204);
  margin-top: 10px;
  padding-left: 10px;
}

#subscribe-submit {
  width: 100px;
  height: 30px;
  margin-top: 15px;
  grid-area: submit;
  color: white;
  font-weight: 600;
  border: 1px solid rgb(102 153 204);
  background-color: rgb(102 153 204);
}

#blurbs,
#friends {
  padding-bottom: 20px;
}

#blurbs-name,
#friends-name,
#comments-name {
  background-color: rgb(254 205 153);
  padding: 0 10px;
  height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: rgb(255 105 15);
  box-sizing: border-box;
  word-break: break-all;
  white-space: pre-wrap;
}

#blurbs-name-text,
#friends-name-text,
#comments-name-text {
  white-space: nowrap;
  margin-left: -4px;
}

#blurbs-about {
  white-space: pre-wrap;
}

#blurbs-about-me,
#blurbs-about-meet {
  display: flex;
  align-items: flex-end;
  height: 30px;
  color: rgb(255 105 15);
  font-weight: 600;
}

#friends-count {
  height: 35px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 15px;
  font-weight: 600;
}

#friends-count-name {
  box-sizing: border-box;
  word-break: break-all;
  white-space: pre-wrap;
}

#friends-count-text {
  white-space: pre;
}

#friends-count-text-end {
  white-space: pre;
}

#friends-count-current {
  color: rgb(204 2 0);
  font-weight: 100;
  white-space: nowrap;
}

#friends-top {
  display: grid;
  grid-template-columns: auto auto auto auto;
  grid-template-rows: auto auto;
  justify-content: space-between;
}

.friends-top-icon {
  width: 140px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: auto;
  padding-bottom: 30px;
  flex: 1;

  /* flex-basis: 25%; */
}

.friends-top-icon-name {
  font-weight: 600;
  width: 140px;
  line-height: 15px;
  text-align: center;
  padding-bottom: 10px;
  word-break: break-all;
}

.friends-top-icon-img {
  width: 140px;
  height: 160px;
  object-fit: cover;
}

#friends-view-all {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  height: 20px;
  color: rgb(204 2 0);
  font-weight: 600;
  text-decoration: none;
}

#friends-view-all-name {
  word-break: break-all;
  white-space: pre-wrap;
}

#friends-view-all-text {
  white-space: pre;
}

#friends-view-all-text-end {
  white-space: pre;
  margin-left: -4px;
}

#comments-count {
  height: 35px;
  display: flex;
  align-items: flex-end;
  padding-bottom: 15px;
  white-space: pre;
  font-weight: 600;
}

#comments-count-current,
#comments-count-total {
  color: rgb(204 2 0);
  font-weight: 100;
}

.comments-post {
  display: grid;
  grid-template-areas: "left right";
  border-bottom: 2px solid white;
  grid-template-columns: 225px auto;
}

.comments-post-left {
  grid-area: left;
  background-color: rgb(255 153 51);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 2px solid white;
  padding: 10px;
}

.comments-post-left-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 140px;
}

.comments-post-left-name,
.comments-post-right-date {
  line-height: 35px;
  font-weight: 600;
}

.comments-post-left-name {
  word-break: break-all;
  white-space: pre-wrap;
}

.comments-post-left-pic {
  width: 140px;
  height: 160px;
  object-fit: cover;
  padding-bottom: 20px;
}

.comments-post-right {
  grid-area: right;
  background-color: rgb(248 214 180);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 10px 10px 10px 20px;
}

/* Content */

#content-layout {
  padding: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#content-list-title {
  display: flex;
  flex-direction: row;
  background-color: rgb(102 153 204);
  height: 30px;
  align-items: center;
  color: white;
}

#content-post-area {
  justify-self: left;
}

#content-foot {
  align-self: center;
  padding-top: 30px;
}

#content-foot-card {
  background-color: rgb(214 231 251);
  width: 600px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 15px 20px;
}

#content-foot-info {
  display: flex;
  flex-direction: row;
}

#content-foot-pic {
  width: 70px;
}

#content-foot-profile {
  width: 100%;
}

.content-foot-about,
.content-foot-profile-link {
  word-break: break-word;
  white-space: pre-wrap;
  font-size: 12px;
  line-height: auto;
  padding-left: 10px;
}

.content-foot-profile-link {
  padding-top: 5px;
  text-align: right;
}

.content-firstName,
.content-lastName {
  padding-bottom: 10px;
  color: black;
  cursor: default;
  word-break: break-all;
  width: 100%;
  font-size: 16px;
}

.content-post {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 60px;
  color: rgb(1 50 153);
  font-weight: 600;
  text-decoration: none;
  padding: 0 20px;
  line-height: 18px;
}

.content-post:hover {
  background-color: rgb(214 231 251);
  cursor: pointer;
}

.content-post.selected {
  background-color: rgb(214 231 251);
}

.content-post-title {
  word-break: break-all;
  white-space: pre-wrap;
}

#content-current-post {
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 750px;
}

#content-current-post-title {
  padding: 20px 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  width: 100%;
}

#content-current-post-text {
  line-height: 22px;
}

#content-current-post-share {
  font-size: 10px;
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  white-space: pre;
  justify-content: flex-end;
  width: 644px;
  align-self: flex-end;
}

#content-updates {
  padding-top: 40px;
}

#editor-container {
  width: 500px;
  height: 200px;
}
`, "",{"version":3,"sources":["webpack://./client/src/styles.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;;;EAME,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA,iBAAiB;;AAEjB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,YAAY;;AAEZ;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,sBAAsB;;AAEtB;EACE,aAAa;EACb,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B;;UAEQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;EAME,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,6CAA6C;EAC7C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;EAIE,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;EAYE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,uBAAuB;;AAEvB;EACE,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mCAAmC;AACrC;;AAEA;;;;EAIE,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,aAAa;EACb,gCAAgC;EAChC,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;EAGE,kCAAkC;EAClC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,OAAO;;EAEP,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,YAAY;;AAEZ;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":["body {\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n  background-color: lightgray;\n  margin: 0;\n  line-height: 20px;\n  font-size: 14px;\n}\n\np {\n  margin: 10px 0 0;\n}\n\na {\n  color: rgb(1 50 153);\n  font-weight: 600;\n  text-decoration: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 600;\n  margin: 0;\n}\n\nh3 a:visited {\n  color: black;\n}\n\nh3 {\n  font-size: 20px;\n}\n\nh4 {\n  font-size: 17px;\n}\n\nh5 {\n  font-size: 14px;\n}\n\nh6 {\n  font-size: 13px;\n}\n\nul {\n  margin: 0;\n}\n\n.a-button {\n  color: rgb(1 50 153);\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0 1px;\n}\n\n#app {\n  background-color: rgb(102 153 204);\n  width: 1310px;\n  height: auto;\n  margin: auto;\n  overflow: hidden;\n}\n\n#header {\n  height: 250px;\n  background-color: rgb(1 50 153);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n#header-info {\n  color: white;\n  align-self: flex-end;\n  padding: 0 30px 0 0;\n  height: 5px;\n}\n\n#header-info span {\n  color: white;\n  align-self: flex-end;\n  font-weight: 400;\n}\n\n#header-pic-img {\n  height: 180px;\n  object-fit: cover;\n}\n\n#nav {\n  height: 3vh;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  background-color: rgb(102 153 204);\n}\n\n#nav a {\n  color: white;\n  font-weight: 400;\n}\n\n#nav-div {\n  width: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#footer {\n  height: 10vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  border-top: 2px solid white;\n  background-color: lightgray;\n}\n\n#footer-nav {\n  height: 3vh;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  background-color: lightgray;\n}\n\n#footer-nav a {\n  font-weight: 400;\n}\n\n#footer-copyright {\n  display: flex;\n  align-items: flex-end;\n  height: 50px;\n  font-size: 10px;\n}\n\n/* Landing Page */\n\n#landing {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  padding: 40px;\n}\n\n#landing-main {\n  background-color: lightgray;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n#landing-main-logo {\n  padding-bottom: 10px;\n}\n\n#landing-main-logo-img {\n  width: 50px;\n  padding-bottom: 20px;\n}\n\n#landing-action {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  white-space: pre;\n  padding-top: 15px;\n}\n\n/* Profile */\n\n#profile,\n#content {\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  padding: 0 50px 50px;\n}\n\n.profile-firstName,\n.profile-lastName {\n  padding: 30px 0 20px;\n  color: black;\n  cursor: default;\n  word-break: break-all;\n}\n\n#profile-layout {\n  height: 100%;\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-template-areas: \"left right\";\n}\n\n#profile-left {\n  grid-area: left;\n  width: 400px;\n  padding-right: 25px;\n  justify-self: left;\n}\n\n#profile-right {\n  grid-area: right;\n  min-width: 450px;\n  width: 760px;\n  padding-left: 25px;\n  justify-self: left;\n}\n\n/* Profile Left Side */\n\n#description {\n  display: grid;\n  grid-template: \"name name\" auto \"pic desc\" 200px \"mood login\" 75px / 250px;\n}\n\n#description-pic {\n  grid-area: pic;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#description-pic-img {\n  width: 100%;\n  object-fit: cover;\n}\n\n#description-mood-view {\n  grid-area: mood;\n  white-space: pre;\n  padding: 18px 20px 0 0;\n  height: 20px;\n  display: grid;\n  grid-template-rows: 22px auto;\n  grid-template-areas:\n    \"mood\"\n    \"view\";\n}\n\n#description-mood {\n  display: flex;\n  flex-direction: row;\n  grid-area: mood;\n}\n\n#description-mood-name {\n  height: 25px;\n}\n\n#description-mood-current {\n  height: 25px;\n  grid-area: current;\n  justify-self: flex-start;\n}\n\n#description-mood-current-emoji {\n  height: 25px;\n  grid-area: emoji;\n  justify-self: flex-start;\n}\n\n#description-view-pics {\n  height: 20px;\n  grid-area: view;\n  display: flex;\n  flex-direction: row;\n  white-space: pre;\n}\n\n#description-view-pics a {\n  font-weight: 600;\n}\n\n#description-desc {\n  white-space: pre;\n  padding: 0 20px;\n  grid-area: desc;\n  display: flex;\n  flex-direction: column;\n}\n\n#description-desc-status {\n  height: 40px;\n  display: flex;\n  flex-direction: row;\n  white-space: pre;\n}\n\n#description-desc-status-text {\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n#description-desc-status-text-quote {\n  margin-left: -4px;\n}\n\n#description-desc-gender,\n#description-desc-age,\n#description-desc-city,\n#description-desc-state,\n#description-desc-country,\n#description-desc-login-date {\n  height: 20px;\n}\n\n#description-desc-login {\n  height: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n#contact-layout {\n  line-height: 15px;\n  display: grid;\n  grid-template: \"left right\" auto / 180px auto;\n  white-space: pre;\n  box-sizing: border-box;\n}\n\n#contact-name,\n#interests-name,\n#details-name,\n#content-list-name {\n  height: 30px;\n  background-color: rgb(102 153 204);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 10px;\n  color: white;\n  box-sizing: border-box;\n  word-break: break-all;\n  white-space: pre-wrap;\n  margin-top: -2px;\n}\n\n#contact-name-text {\n  white-space: pre;\n}\n\n#details-name-text,\n#interests-name-text,\n#content-list-name-text {\n  white-space: pre;\n  margin-left: -4px;\n}\n\n#contact-left {\n  grid-area: left;\n  padding: 20px 0 20px 10px;\n  justify-self: center;\n}\n\n#contact-right {\n  grid-area: right;\n  padding: 20px 10px 20px 0;\n}\n\n.contact-link {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 7px 0;\n  height: 20px;\n}\n\n.contact-icon {\n  font-size: 20px;\n  padding: 0 10px 0 20px;\n}\n\n#url {\n  border: 1px solid rgb(102 153 204);\n  padding: 5px 10px;\n  width: 100%;\n  box-sizing: border-box;\n  margin-bottom: 30px;\n}\n\n#url-name,\n#url-address {\n  display: flex;\n  align-items: center;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n#url-address {\n  padding: 0 15px;\n}\n\n#url-address-text {\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n#url-name {\n  font-weight: 600;\n}\n\n#interests,\n#details,\n#contact,\n#content-list {\n  border: 2px solid rgb(102 153 204);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  margin-bottom: 15px;\n}\n\n#contact,\n#content-list {\n  margin-bottom: 30px;\n}\n\n#interests-name,\n#details-name {\n  padding-left: 10px;\n}\n\n#interests-main,\n#details-main {\n  padding: 4px 0 0 4px;\n}\n\n#interests-general,\n#interests-music,\n#interests-movies,\n#interests-television,\n#interests-books,\n#interests-heroes,\n#details-status,\n#details-here,\n#details-hometown,\n#details-zodiac,\n#details-smoke,\n#details-occupation {\n  display: flex;\n  flex-direction: row;\n  padding: 0 4px 4px 0;\n}\n\n.interests-left,\n.details-left {\n  grid-area: left;\n  width: 150px;\n  margin-right: 4px;\n  background-color: rgb(177 208 240);\n}\n\n.interests-right,\n.details-right {\n  grid-area: right;\n  width: 250px;\n  background-color: rgb(214 231 251);\n}\n\n.interests-section,\n.details-section {\n  color: rgb(52 102 153);\n  min-height: 30px;\n  padding: 4px;\n  width: 100% - 4px;\n  height: 100% - 4px;\n}\n\n.interests-text,\n.details-text {\n  min-height: 30px;\n  padding: 4px;\n  width: 100% - 4px;\n  height: 100% - 4px;\n}\n\n/* Profile Right Side */\n\n#headline {\n  border: 2px solid black;\n  padding: 35px;\n  line-height: 30px;\n  height: 130px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n#headline-name {\n  word-break: break-all;\n  white-space: pre-wrap;\n}\n\n#headline-text {\n  word-break: break-all;\n  white-space: pre-wrap;\n}\n\n#headline-text-content {\n  white-space: pre;\n}\n\n#profile-content {\n  padding: 25px 0;\n  display: grid;\n  grid-template: \"center\" auto / auto;\n}\n\n#profile-content-title,\n#profile-content-title-name,\n#profile-content-subscribe,\n#profile-content-head {\n  height: 20px;\n  padding-bottom: 20px;\n  display: flex;\n  flex-direction: row;\n  white-space: nowrap;\n}\n\n#profile-content-title-name {\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n#profile-content-title-text {\n  white-space: nowrap;\n  margin-left: -4px;\n}\n\n#profile-content-subscribe {\n  padding-left: 5px;\n}\n\n#profile-content-text {\n  grid-area: center;\n  width: 100%;\n}\n\n.profile-content-post {\n  width: auto;\n  height: 20px;\n  padding-bottom: 20px;\n  display: flex;\n}\n\n.profile-content-post-title {\n  width: auto;\n  word-break: break-all;\n  white-space: pre-wrap;\n}\n\n.profile-content-post-more {\n  white-space: nowrap;\n}\n\n#profile-content-view-all {\n  display: flex;\n  flex-direction: row;\n}\n\n#subscribe {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: rgb(255 255 255 / 50%);\n  grid-area: center;\n  z-index: 1;\n  padding-top: 30px;\n}\n\n#subscribe-name {\n  height: 30px;\n  background-color: rgb(102 153 204);\n  display: grid;\n  grid-template-columns: auto 20px;\n  grid-template-rows: auto;\n  padding-left: 10px;\n  color: white;\n  box-sizing: border-box;\n  align-items: center;\n}\n\n#subscribe-box {\n  background-color: rgb(214 231 251);\n  border: 2px solid rgb(102 153 204);\n  width: 100%;\n  min-width: 200px;\n  max-width: 400px;\n  height: 200px;\n  display: flex;\n  flex-direction: column;\n}\n\n#subscribe-close {\n  font-size: 16px;\n  color: white;\n  cursor: pointer;\n}\n\n#subscribe-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: rgb(52 102 153);\n  line-height: 20px;\n  margin: auto;\n  padding: 20px;\n}\n\n#subscribe-text form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 5px;\n}\n\n#subscribe-text-name {\n  word-break: break-all;\n  white-space: pre-wrap;\n  display: flex;\n  flex-direction: row;\n}\n\n#subscribe-text-name-text {\n  white-space: pre;\n}\n\n#subscribe-email {\n  width: 200px;\n  height: 20px;\n  grid-area: email;\n  border: 1px solid rgb(102 153 204);\n  margin-top: 10px;\n  padding-left: 10px;\n}\n\n#subscribe-submit {\n  width: 100px;\n  height: 30px;\n  margin-top: 15px;\n  grid-area: submit;\n  color: white;\n  font-weight: 600;\n  border: 1px solid rgb(102 153 204);\n  background-color: rgb(102 153 204);\n}\n\n#blurbs,\n#friends {\n  padding-bottom: 20px;\n}\n\n#blurbs-name,\n#friends-name,\n#comments-name {\n  background-color: rgb(254 205 153);\n  padding: 0 10px;\n  height: 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: rgb(255 105 15);\n  box-sizing: border-box;\n  word-break: break-all;\n  white-space: pre-wrap;\n}\n\n#blurbs-name-text,\n#friends-name-text,\n#comments-name-text {\n  white-space: nowrap;\n  margin-left: -4px;\n}\n\n#blurbs-about {\n  white-space: pre-wrap;\n}\n\n#blurbs-about-me,\n#blurbs-about-meet {\n  display: flex;\n  align-items: flex-end;\n  height: 30px;\n  color: rgb(255 105 15);\n  font-weight: 600;\n}\n\n#friends-count {\n  height: 35px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-bottom: 15px;\n  font-weight: 600;\n}\n\n#friends-count-name {\n  box-sizing: border-box;\n  word-break: break-all;\n  white-space: pre-wrap;\n}\n\n#friends-count-text {\n  white-space: pre;\n}\n\n#friends-count-text-end {\n  white-space: pre;\n}\n\n#friends-count-current {\n  color: rgb(204 2 0);\n  font-weight: 100;\n  white-space: nowrap;\n}\n\n#friends-top {\n  display: grid;\n  grid-template-columns: auto auto auto auto;\n  grid-template-rows: auto auto;\n  justify-content: space-between;\n}\n\n.friends-top-icon {\n  width: 140px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  height: auto;\n  padding-bottom: 30px;\n  flex: 1;\n\n  /* flex-basis: 25%; */\n}\n\n.friends-top-icon-name {\n  font-weight: 600;\n  width: 140px;\n  line-height: 15px;\n  text-align: center;\n  padding-bottom: 10px;\n  word-break: break-all;\n}\n\n.friends-top-icon-img {\n  width: 140px;\n  height: 160px;\n  object-fit: cover;\n}\n\n#friends-view-all {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  height: 20px;\n  color: rgb(204 2 0);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n#friends-view-all-name {\n  word-break: break-all;\n  white-space: pre-wrap;\n}\n\n#friends-view-all-text {\n  white-space: pre;\n}\n\n#friends-view-all-text-end {\n  white-space: pre;\n  margin-left: -4px;\n}\n\n#comments-count {\n  height: 35px;\n  display: flex;\n  align-items: flex-end;\n  padding-bottom: 15px;\n  white-space: pre;\n  font-weight: 600;\n}\n\n#comments-count-current,\n#comments-count-total {\n  color: rgb(204 2 0);\n  font-weight: 100;\n}\n\n.comments-post {\n  display: grid;\n  grid-template-areas: \"left right\";\n  border-bottom: 2px solid white;\n  grid-template-columns: 225px auto;\n}\n\n.comments-post-left {\n  grid-area: left;\n  background-color: rgb(255 153 51);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-right: 2px solid white;\n  padding: 10px;\n}\n\n.comments-post-left-icon {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 140px;\n}\n\n.comments-post-left-name,\n.comments-post-right-date {\n  line-height: 35px;\n  font-weight: 600;\n}\n\n.comments-post-left-name {\n  word-break: break-all;\n  white-space: pre-wrap;\n}\n\n.comments-post-left-pic {\n  width: 140px;\n  height: 160px;\n  object-fit: cover;\n  padding-bottom: 20px;\n}\n\n.comments-post-right {\n  grid-area: right;\n  background-color: rgb(248 214 180);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 10px 10px 10px 20px;\n}\n\n/* Content */\n\n#content-layout {\n  padding: 60px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n#content-list-title {\n  display: flex;\n  flex-direction: row;\n  background-color: rgb(102 153 204);\n  height: 30px;\n  align-items: center;\n  color: white;\n}\n\n#content-post-area {\n  justify-self: left;\n}\n\n#content-foot {\n  align-self: center;\n  padding-top: 30px;\n}\n\n#content-foot-card {\n  background-color: rgb(214 231 251);\n  width: 600px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 15px 20px;\n}\n\n#content-foot-info {\n  display: flex;\n  flex-direction: row;\n}\n\n#content-foot-pic {\n  width: 70px;\n}\n\n#content-foot-profile {\n  width: 100%;\n}\n\n.content-foot-about,\n.content-foot-profile-link {\n  word-break: break-word;\n  white-space: pre-wrap;\n  font-size: 12px;\n  line-height: auto;\n  padding-left: 10px;\n}\n\n.content-foot-profile-link {\n  padding-top: 5px;\n  text-align: right;\n}\n\n.content-firstName,\n.content-lastName {\n  padding-bottom: 10px;\n  color: black;\n  cursor: default;\n  word-break: break-all;\n  width: 100%;\n  font-size: 16px;\n}\n\n.content-post {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  height: 60px;\n  color: rgb(1 50 153);\n  font-weight: 600;\n  text-decoration: none;\n  padding: 0 20px;\n  line-height: 18px;\n}\n\n.content-post:hover {\n  background-color: rgb(214 231 251);\n  cursor: pointer;\n}\n\n.content-post.selected {\n  background-color: rgb(214 231 251);\n}\n\n.content-post-title {\n  word-break: break-all;\n  white-space: pre-wrap;\n}\n\n#content-current-post {\n  padding: 30px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 750px;\n}\n\n#content-current-post-title {\n  padding: 20px 0;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  width: 100%;\n}\n\n#content-current-post-text {\n  line-height: 22px;\n}\n\n#content-current-post-share {\n  font-size: 10px;\n  padding-top: 10px;\n  display: flex;\n  flex-direction: row;\n  white-space: pre;\n  justify-content: flex-end;\n  width: 644px;\n  align-self: flex-end;\n}\n\n#content-updates {\n  padding-top: 40px;\n}\n\n#editor-container {\n  width: 500px;\n  height: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
